import React from "react";
import { useTranslation } from "react-i18next";
import "../styles/pages/Support.css";

const SUPPORT_EMAIL = "info@reelitpro.com";

export default function Support() {
  const { t } = useTranslation();

  return (
    <main className="support-page">
      <section className="support-page__panel" aria-labelledby="support-title">
        <p className="support-page__eyebrow">
          {t("support_page_eyebrow", { defaultValue: "Customer support" })}
        </p>
        <h1 id="support-title">
          {t("support_page_title", { defaultValue: "Support" })}
        </h1>
        <p className="support-page__intro">
          {t("support_page_intro", {
            defaultValue:
              "Need help with ReelitPro? Contact support and we will get back to you as soon as we can.",
          })}
        </p>

        <a className="support-page__email" href={`mailto:${SUPPORT_EMAIL}`}>
          {SUPPORT_EMAIL}
        </a>
      </section>
    </main>
  );
}
